import { observable, action, toJS } from 'mobx'
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import Api from '@api/shou_xie/showCase'
import { message } from 'hljd'

export default class {
  constructor(stepTwoStore) {
    // 整个第二步的store
    this.stepTwoStore = stepTwoStore
  }
  @observable propertyId = null
  // 接口获取的案例列表 待上传
  @observable caseList = []
  // 最终选择的案例列表
  @observable setMeal = []
  // 待编辑区选择的案例 （没有点击保存）
  @observable preSetMeal = []
  // mode add 添加 replace 替换
  @observable mode = 'add'
  // 禁选列表 replace 模式下生效
  @observable disabledMealList = []
  // 替换的index
  @observable replaceIndex = 0
  @observable searchParam = ''

  @observable getCaseListLoading = false
  @observable caseListHasNext = true // 滚动到底部加载
  @observable currentPage = 0 // 滚动到底部加载
  per_page = 30

  @action
  save = () => {
    // 处理数据
    this.stepTwoStore.sessionCase = this.setMeal
    this.stepTwoStore.setStepTwoData()
  }
  @action
  init = () => {
    this.resetPageInfo()
    this.propertyId = this.stepTwoStore.centerStore.property_id
    this.setMeal = this.stepTwoStore.stepTwoData.set_meal_relation || []
    this.getCaseList()
    this.disabledMealList = this.setMeal.map(el => {
      // this.selectcase(true, el.data.id)
      return el.data.id
    })
    this.preSetMeal = cloneDeep(toJS(this.setMeal))
  }
  @action
  refresh = () => {
    this.resetPageInfo()
    this.getCaseList()
  }

  // shouldClear 是否清楚之前的列表数据
  @action
  getCaseList = async shouldClear => {
    // 获取案例
    this.getCaseListLoading = true
    const { success, data } = await Api.setMealListApi2({
      page: this.currentPage + 1,
      per_page: this.per_page,
      title: this.searchParam
    })

    this.getCaseListLoading = false

    if (success) {
      const { list, page_count, total_count } = data
      const newList = list.map(el => ({
        ...el,
        id: el.example_id,
        set_meal_created_at: el.created_at
      }))
      this.currentPage++
      if (
        page_count == 0 ||
        page_count <= this.currentPage ||
        total_count <= this.per_page
      ) {
        this.caseListHasNext = false
      }
      this.caseList = [...(shouldClear ? [] : this.caseList), ...newList]
    }
  }
  @action
  handleChangeSearchParam = e => {
    this.currentPage = 0
    this.caseListHasNext = true
    this.searchParam = e.target.value
  }

  resetPageInfo = () => {
    this.currentPage = 0
    this.caseListHasNext = true
    this.caseList = []
  }
  @action
  handleChangeCaseList = debounce(e => {
    this.getCaseList(true)
  }, 1000)

  @action
  addCase = () => {
    this.mode = 'add'
    this.preSetMeal = cloneDeep(toJS(this.setMeal))
    this.getCaseList()
  }
  @action
  saveCase = () => {
    if (this.mode === 'add') {
      this.setMeal = cloneDeep(toJS(this.preSetMeal))
      // this.preSetMeal = []
    } else {
      if (this.preSetMeal.length) {
        this.setMeal[this.replaceIndex] = this.preSetMeal[0]
      } else {
        this.discard(this.replaceIndex)
      }
    }
    this.save()
    // this.searchParam = ''
  }
  @action
  selectcase = (value, id, isServiceRelated) => {
    if (isServiceRelated) {
      message.warning('案例已被定制服务关联，请重新选择')
    }
    if (this.disabledMealList.includes(id + '') || isServiceRelated) {
      return
    }
    if (value) {
      if (this.mode === 'add') {
        if (this.setMeal.length >= 20) {
          message.warning('关联案例数量不可超过20个')
          return
        }
        this.preSetMeal = [
          ...this.preSetMeal,
          {
            data: this.caseList.find(el => el.id === id),
            status: false
          }
        ]
      } else if (this.mode === 'replace') {
        this.preSetMeal = [
          {
            data: this.caseList.find(el => el.id === id),
            status: false
          }
        ]
      }
    } else {
      this.preSetMeal = this.preSetMeal.filter(el => el.data.id !== id)
    }

    this.saveCase()
  }
  @action
  activation = index => {
    this.setMeal = this.setMeal.map((el, i) => {
      return {
        ...el,
        status: index === i
      }
    })
  }
  @action
  motivation = (type, index) => {
    if (index != 0 && type == 'up') {
      ;[this.setMeal[index - 1], this.setMeal[index]] = [
        this.setMeal[index],
        this.setMeal[index - 1]
      ]
    } else if (index != this.setMeal.length - 1 && type == 'down') {
      ;[this.setMeal[index + 1], this.setMeal[index]] = [
        this.setMeal[index],
        this.setMeal[index + 1]
      ]
    }
    this.preSetMeal = cloneDeep(toJS(this.setMeal))
    this.save()
  }
  @action
  discard = index => {
    const list = this.setMeal
    list.splice(index, 1)
    this.setMeal = list
    this.preSetMeal = cloneDeep(toJS(this.setMeal))
    this.save()
  }
  @action
  replace = (el, i) => {
    this.mode = 'replace'
    this.preSetMeal = [el]
    this.replaceIndex = i
    this.disabledMealList = this.setMeal
      .filter(item => item.data.id != el.data.id)
      .map(item => item.data.id + '')
    this.save()
  }
}
